import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-67022532"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icon-close" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "15.506134",
  height: "15.506104",
  viewBox: "0 0 15.5061 15.5061",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, [
  /*#__PURE__*/_createElementVNode("desc", null, "Created with Pixso."),
  /*#__PURE__*/_createElementVNode("defs"),
  /*#__PURE__*/_createElementVNode("path", {
    id: "path (Border)",
    d: "M0.22 0.22C-0.08 0.51 -0.08 0.98 0.22 1.28L6.69 7.75L0.22 14.22C-0.08 14.51 -0.08 14.98 0.22 15.28C0.51 15.58 0.98 15.58 1.28 15.28L7.75 8.81L14.22 15.28C14.51 15.58 14.98 15.58 15.28 15.28C15.58 14.98 15.58 14.51 15.28 14.22L8.81 7.75L15.28 1.28C15.42 1.13 15.5 0.96 15.5 0.75C15.5 0.54 15.42 0.36 15.28 0.22C15.13 0.07 14.96 0 14.75 0C14.54 0 14.36 0.07 14.22 0.22L7.75 6.69L1.28 0.22C0.98 -0.08 0.51 -0.08 0.22 0.22L0.22 0.22Z",
    fill: "#77797C",
    "fill-opacity": "1.000000",
    "fill-rule": "evenodd"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}